// Physiomobile Loyalty Programme Mock Data

// User wallet data
export const userWallet = {
  id: 'usr_12345',
  name: 'Sarah Chen',
  email: 'sarah.chen@email.com',
  memberSince: '2023-06-15',
  tier: 'Gold',
  totalPoints: 12450,
  availablePoints: 11200,
  pendingPoints: 1250,
  expiringPoints: 1850,
  expiringDate: '2024-03-31',
  daysToExpiry: 21,
  lifetimeEarned: 45600,
  lifetimeRedeemed: 34200,
  referralCode: 'SARAH2024',
  referralCount: 7,
  streakDays: 12,
  lastSessionDate: '2024-03-10',
};

// Monthly points data for charts
export const monthlyPointsData = [
  { month: 'Oct', earned: 2800, redeemed: 1200 },
  { month: 'Nov', earned: 3200, redeemed: 2500 },
  { month: 'Dec', earned: 4100, redeemed: 1800 },
  { month: 'Jan', earned: 3600, redeemed: 2200 },
  { month: 'Feb', earned: 2900, redeemed: 3100 },
  { month: 'Mar', earned: 1850, redeemed: 800 },
];

// Earn methods
export const earnMethods = [
  {
    id: 'earn_physio',
    title: 'Physiotherapy Sessions',
    description: 'Earn points for every physiotherapy session completed',
    pointsPerAction: 150,
    icon: 'activity',
    color: 'primary',
    category: 'session',
  },
  {
    id: 'earn_ot',
    title: 'Occupational Therapy',
    description: 'Earn points for OT sessions',
    pointsPerAction: 150,
    icon: 'hand',
    color: 'info',
    category: 'session',
  },
  {
    id: 'earn_speech',
    title: 'Speech Therapy',
    description: 'Earn points for speech therapy sessions',
    pointsPerAction: 150,
    icon: 'mic',
    color: 'success',
    category: 'session',
  },
  {
    id: 'earn_diet',
    title: 'Diet & Nutrition',
    description: 'Earn points for nutrition consultations',
    pointsPerAction: 100,
    icon: 'apple',
    color: 'warning',
    category: 'session',
  },
  {
    id: 'earn_care',
    title: 'Care & Companion',
    description: 'Earn points for care services',
    pointsPerAction: 80,
    icon: 'heart',
    color: 'destructive',
    category: 'session',
  },
];

// Streak rewards
export const streakRewards = [
  { days: 7, bonus: 200, achieved: true },
  { days: 14, bonus: 500, achieved: false, progress: 12 },
  { days: 30, bonus: 1500, achieved: false, progress: 12 },
  { days: 60, bonus: 4000, achieved: false, progress: 12 },
];

// Active challenges
export const activeChallenges = [
  {
    id: 'chal_1',
    title: 'March Wellness Challenge',
    description: 'Complete 8 sessions this month',
    reward: 1000,
    progress: 5,
    target: 8,
    endDate: '2024-03-31',
    status: 'active',
  },
  {
    id: 'chal_2',
    title: 'Refer a Friend',
    description: 'Invite 3 friends to join Physiomobile',
    reward: 2000,
    progress: 2,
    target: 3,
    endDate: '2024-04-15',
    status: 'active',
  },
];

// Internal redemption items (Physiomobile)
export const internalRedemptions = [
  {
    id: 'red_int_1',
    title: 'RM50 Session Discount',
    description: 'Get RM50 off your next physiotherapy session',
    pointsCost: 2500,
    savingsValue: 'RM50',
    category: 'discount',
    validity: '30 days',
    serviceTypes: ['Physiotherapy'],
    available: true,
  },
  {
    id: 'red_int_2',
    title: 'Free Diet Consultation',
    description: 'Complimentary 30-min nutrition consultation',
    pointsCost: 3000,
    savingsValue: 'RM80',
    category: 'free_session',
    validity: '60 days',
    serviceTypes: ['Diet & Nutrition'],
    available: true,
  },
  {
    id: 'red_int_3',
    title: '2 Hours Care Service',
    description: 'Free 2-hour care & companion service',
    pointsCost: 4000,
    savingsValue: 'RM120',
    category: 'free_session',
    validity: '60 days',
    serviceTypes: ['Care & Companion'],
    available: true,
  },
  {
    id: 'red_int_4',
    title: 'OT Session Upgrade',
    description: 'Upgrade to premium OT session package',
    pointsCost: 1800,
    savingsValue: 'RM40',
    category: 'upgrade',
    validity: '30 days',
    serviceTypes: ['Occupational Therapy'],
    available: true,
  },
  {
    id: 'red_int_5',
    title: 'Family Session Bundle',
    description: 'Book family sessions at 20% off',
    pointsCost: 5000,
    savingsValue: 'RM150',
    category: 'bundle',
    validity: '90 days',
    serviceTypes: ['All Services'],
    available: false,
  },
];

// Partner categories
export const partnerCategories = [
  { id: 'fitness', name: 'Fitness', icon: 'dumbbell', count: 12 },
  { id: 'wellness', name: 'Wellness', icon: 'spa', count: 8 },
  { id: 'pharmacy', name: 'Pharmacy', icon: 'pill', count: 15 },
  { id: 'food', name: 'Healthy Food', icon: 'utensils', count: 20 },
  { id: 'devices', name: 'Medical Devices', icon: 'stethoscope', count: 6 },
];

// Partner offers
export const partnerOffers = [
  {
    id: 'part_1',
    partnerId: 'partner_gym1',
    partnerName: 'FitLife Gym',
    partnerLogo: '/api/placeholder/48/48',
    title: 'RM20 Gym Day Pass',
    description: 'Full access to gym facilities for one day',
    pointsCost: 1000,
    originalPrice: 'RM35',
    category: 'fitness',
    distance: '2.3 km',
    expiryDate: '2024-04-30',
    redemptionType: 'voucher',
    featured: true,
    rating: 4.5,
    reviews: 128,
  },
  {
    id: 'part_2',
    partnerId: 'partner_spa1',
    partnerName: 'Serenity Spa',
    partnerLogo: '/api/placeholder/48/48',
    title: '30% Off Massage',
    description: 'Relaxing full body massage at discounted rate',
    pointsCost: 2000,
    originalPrice: 'RM150',
    category: 'wellness',
    distance: '3.8 km',
    expiryDate: '2024-05-15',
    redemptionType: 'qr',
    featured: true,
    rating: 4.8,
    reviews: 256,
  },
  {
    id: 'part_3',
    partnerId: 'partner_pharm1',
    partnerName: 'HealthPlus Pharmacy',
    partnerLogo: '/api/placeholder/48/48',
    title: 'RM15 Voucher',
    description: 'Use on vitamins and supplements',
    pointsCost: 750,
    originalPrice: 'RM15',
    category: 'pharmacy',
    distance: '0.8 km',
    expiryDate: '2024-04-20',
    redemptionType: 'voucher',
    featured: false,
    rating: 4.3,
    reviews: 89,
  },
  {
    id: 'part_4',
    partnerId: 'partner_food1',
    partnerName: 'GreenBowl Kitchen',
    partnerLogo: '/api/placeholder/48/48',
    title: 'Free Smoothie Bowl',
    description: 'Choice of any smoothie bowl from the menu',
    pointsCost: 600,
    originalPrice: 'RM18',
    category: 'food',
    distance: '1.5 km',
    expiryDate: '2024-04-10',
    redemptionType: 'qr',
    featured: true,
    rating: 4.6,
    reviews: 312,
  },
  {
    id: 'part_5',
    partnerId: 'partner_device1',
    partnerName: 'MedTech Store',
    partnerLogo: '/api/placeholder/48/48',
    title: 'RM50 Off Blood Pressure Monitor',
    description: 'Digital BP monitor for home use',
    pointsCost: 2500,
    originalPrice: 'RM50',
    category: 'devices',
    distance: '4.2 km',
    expiryDate: '2024-05-30',
    redemptionType: 'voucher',
    featured: false,
    rating: 4.4,
    reviews: 67,
  },
  {
    id: 'part_6',
    partnerId: 'partner_yoga1',
    partnerName: 'Zen Yoga Studio',
    partnerLogo: '/api/placeholder/48/48',
    title: '3 Yoga Classes',
    description: 'Package of 3 group yoga sessions',
    pointsCost: 1800,
    originalPrice: 'RM90',
    category: 'fitness',
    distance: '2.1 km',
    expiryDate: '2024-04-25',
    redemptionType: 'voucher',
    featured: false,
    rating: 4.7,
    reviews: 198,
  },
];

// User vouchers
export const userVouchers = [
  {
    id: 'vouch_1',
    offerId: 'part_1',
    title: 'RM20 Gym Day Pass',
    partnerName: 'FitLife Gym',
    voucherCode: 'PHYSIO-GYM-A7X9K2',
    status: 'active',
    redeemedDate: '2024-03-08',
    expiryDate: '2024-04-08',
    pointsUsed: 1000,
    redemptionType: 'voucher',
  },
  {
    id: 'vouch_2',
    offerId: 'red_int_1',
    title: 'RM50 Session Discount',
    partnerName: 'Physiomobile',
    voucherCode: 'PHYSIO-DISC-B3M8P5',
    status: 'active',
    redeemedDate: '2024-03-05',
    expiryDate: '2024-04-05',
    pointsUsed: 2500,
    redemptionType: 'voucher',
  },
  {
    id: 'vouch_3',
    offerId: 'part_3',
    title: 'RM15 Pharmacy Voucher',
    partnerName: 'HealthPlus Pharmacy',
    voucherCode: 'PHYSIO-PHAR-C5N2Q8',
    status: 'used',
    redeemedDate: '2024-02-20',
    usedDate: '2024-02-25',
    expiryDate: '2024-03-20',
    pointsUsed: 750,
    redemptionType: 'voucher',
  },
  {
    id: 'vouch_4',
    offerId: 'part_4',
    title: 'Free Smoothie Bowl',
    partnerName: 'GreenBowl Kitchen',
    voucherCode: 'PHYSIO-FOOD-D9R4T1',
    status: 'expired',
    redeemedDate: '2024-01-15',
    expiryDate: '2024-02-15',
    pointsUsed: 600,
    redemptionType: 'qr',
  },
];

// Transaction history
export const transactions = [
  {
    id: 'txn_1',
    type: 'earn',
    source: 'Session',
    description: 'Physiotherapy Session',
    points: 150,
    date: '2024-03-10',
    time: '14:30',
    status: 'completed',
    reference: 'SES-2024-0310-001',
  },
  {
    id: 'txn_2',
    type: 'earn',
    source: 'Streak',
    description: '7-Day Streak Bonus',
    points: 200,
    date: '2024-03-09',
    time: '00:00',
    status: 'completed',
    reference: 'STREAK-7DAY-0309',
  },
  {
    id: 'txn_3',
    type: 'redeem',
    source: 'Partner',
    description: 'FitLife Gym - Day Pass',
    points: -1000,
    date: '2024-03-08',
    time: '11:45',
    status: 'completed',
    reference: 'RED-PART-0308-001',
  },
  {
    id: 'txn_4',
    type: 'earn',
    source: 'Session',
    description: 'Speech Therapy Session',
    points: 150,
    date: '2024-03-07',
    time: '10:00',
    status: 'completed',
    reference: 'SES-2024-0307-001',
  },
  {
    id: 'txn_5',
    type: 'earn',
    source: 'Referral',
    description: 'Friend Signup Bonus (Ahmad)',
    points: 500,
    date: '2024-03-06',
    time: '16:20',
    status: 'completed',
    reference: 'REF-2024-0306-001',
  },
  {
    id: 'txn_6',
    type: 'redeem',
    source: 'Physiomobile',
    description: 'RM50 Session Discount',
    points: -2500,
    date: '2024-03-05',
    time: '09:15',
    status: 'completed',
    reference: 'RED-INT-0305-001',
  },
  {
    id: 'txn_7',
    type: 'earn',
    source: 'Campaign',
    description: 'February Wellness Campaign',
    points: 300,
    date: '2024-03-01',
    time: '00:00',
    status: 'completed',
    reference: 'CAMP-FEB-BONUS',
  },
  {
    id: 'txn_8',
    type: 'adjustment',
    source: 'Admin',
    description: 'Points Correction',
    points: 50,
    date: '2024-02-28',
    time: '15:00',
    status: 'completed',
    reference: 'ADJ-2024-0228-001',
  },
];

// Referral data
export const referralData = {
  code: 'SARAH2024',
  totalInvites: 12,
  successfulSignups: 7,
  pendingRewards: 2,
  earnedFromReferrals: 3500,
  referrals: [
    { name: 'Ahmad R.', status: 'rewarded', date: '2024-03-06', reward: 500 },
    { name: 'Lisa T.', status: 'rewarded', date: '2024-02-20', reward: 500 },
    { name: 'Marcus W.', status: 'pending', date: '2024-03-09', reward: 500 },
    { name: 'Jennifer K.', status: 'invited', date: '2024-03-10', reward: 0 },
  ],
};

// ========== ADMIN DATA ==========

// Admin KPIs
export const adminKPIs = {
  totalPointsIssued: 4250000,
  totalPointsRedeemed: 2890000,
  outstandingLiability: 1360000,
  activeUsers: 12450,
  redemptionRate: 68,
  avgPointsPerUser: 341,
  monthOverMonth: {
    issued: 12.5,
    redeemed: 8.3,
    users: 5.2,
  },
};

// Admin chart data
export const adminChartData = {
  earnVsRedeem: [
    { month: 'Oct', earned: 320000, redeemed: 180000 },
    { month: 'Nov', earned: 380000, redeemed: 220000 },
    { month: 'Dec', earned: 450000, redeemed: 310000 },
    { month: 'Jan', earned: 420000, redeemed: 290000 },
    { month: 'Feb', earned: 390000, redeemed: 340000 },
    { month: 'Mar', earned: 280000, redeemed: 195000 },
  ],
  redemptionByCategory: [
    { name: 'Physiomobile', value: 45, color: 'hsl(var(--chart-1))' },
    { name: 'Fitness', value: 20, color: 'hsl(var(--chart-2))' },
    { name: 'Wellness', value: 15, color: 'hsl(var(--chart-3))' },
    { name: 'Pharmacy', value: 12, color: 'hsl(var(--chart-4))' },
    { name: 'Others', value: 8, color: 'hsl(var(--chart-5))' },
  ],
};

// Top partners
export const topPartners = [
  { name: 'FitLife Gym', redemptions: 1245, revenue: 62250 },
  { name: 'Serenity Spa', redemptions: 892, revenue: 89200 },
  { name: 'HealthPlus Pharmacy', redemptions: 2156, revenue: 32340 },
  { name: 'GreenBowl Kitchen', redemptions: 1678, revenue: 30204 },
  { name: 'Zen Yoga Studio', redemptions: 567, revenue: 51030 },
];

// Points rules
export const pointsRules = [
  {
    id: 'rule_1',
    serviceType: 'Physiotherapy',
    earnRate: 150,
    cap: null,
    multiplier: 1.0,
    streakBonus: true,
    effectiveDate: '2024-01-01',
    status: 'active',
  },
  {
    id: 'rule_2',
    serviceType: 'Occupational Therapy',
    earnRate: 150,
    cap: null,
    multiplier: 1.0,
    streakBonus: true,
    effectiveDate: '2024-01-01',
    status: 'active',
  },
  {
    id: 'rule_3',
    serviceType: 'Speech Therapy',
    earnRate: 150,
    cap: null,
    multiplier: 1.0,
    streakBonus: true,
    effectiveDate: '2024-01-01',
    status: 'active',
  },
  {
    id: 'rule_4',
    serviceType: 'Diet & Nutrition',
    earnRate: 100,
    cap: 400,
    multiplier: 1.0,
    streakBonus: false,
    effectiveDate: '2024-01-01',
    status: 'active',
  },
  {
    id: 'rule_5',
    serviceType: 'Care & Companion',
    earnRate: 80,
    cap: 320,
    multiplier: 1.0,
    streakBonus: false,
    effectiveDate: '2024-01-01',
    status: 'active',
  },
];

// Partners list for admin
export const partnersAdmin = [
  {
    id: 'partner_gym1',
    name: 'FitLife Gym',
    category: 'Fitness',
    status: 'active',
    branches: 5,
    redemptionType: 'voucher',
    conversionRate: 0.02,
    settlementTerms: 'Monthly',
    totalRedemptions: 1245,
    pendingSettlement: 12450,
    contactEmail: 'partner@fitlifegym.com',
  },
  {
    id: 'partner_spa1',
    name: 'Serenity Spa',
    category: 'Wellness',
    status: 'active',
    branches: 3,
    redemptionType: 'qr',
    conversionRate: 0.025,
    settlementTerms: 'Bi-weekly',
    totalRedemptions: 892,
    pendingSettlement: 22300,
    contactEmail: 'partner@serenityspa.com',
  },
  {
    id: 'partner_pharm1',
    name: 'HealthPlus Pharmacy',
    category: 'Pharmacy',
    status: 'active',
    branches: 12,
    redemptionType: 'voucher',
    conversionRate: 0.015,
    settlementTerms: 'Weekly',
    totalRedemptions: 2156,
    pendingSettlement: 8420,
    contactEmail: 'partner@healthplus.com',
  },
  {
    id: 'partner_pending1',
    name: 'ActiveLife Sports',
    category: 'Fitness',
    status: 'pending',
    branches: 2,
    redemptionType: 'voucher',
    conversionRate: 0.02,
    settlementTerms: 'Monthly',
    totalRedemptions: 0,
    pendingSettlement: 0,
    contactEmail: 'partner@activelife.com',
  },
];

// Fraud flags
export const fraudFlags = [
  {
    id: 'fraud_1',
    userId: 'usr_99887',
    userName: 'John Suspicious',
    flagReason: 'Unusual earn velocity',
    details: '500+ points earned in 24 hours from single source',
    date: '2024-03-09',
    status: 'pending_review',
    riskLevel: 'high',
  },
  {
    id: 'fraud_2',
    userId: 'usr_88776',
    userName: 'Multiple Account',
    flagReason: 'Multiple accounts detected',
    details: 'Same device ID linked to 3 accounts',
    date: '2024-03-08',
    status: 'pending_review',
    riskLevel: 'medium',
  },
  {
    id: 'fraud_3',
    userId: 'usr_77665',
    userName: 'Excess Redeemer',
    flagReason: 'Excess redemptions',
    details: '15 redemptions in 1 hour',
    date: '2024-03-07',
    status: 'resolved',
    riskLevel: 'low',
    resolution: 'Legitimate bulk purchase for corporate event',
  },
];

// Campaigns for admin
export const campaignsAdmin = [
  {
    id: 'camp_1',
    name: 'March Wellness Challenge',
    status: 'active',
    startDate: '2024-03-01',
    endDate: '2024-03-31',
    targetSegment: 'All Users',
    rewardType: 'bonus_points',
    budgetCap: 50000,
    budgetUsed: 18500,
    participants: 456,
    completions: 89,
  },
  {
    id: 'camp_2',
    name: 'New User Welcome',
    status: 'active',
    startDate: '2024-01-01',
    endDate: '2024-12-31',
    targetSegment: 'New Users',
    rewardType: 'bonus_points',
    budgetCap: 100000,
    budgetUsed: 42000,
    participants: 840,
    completions: 840,
  },
  {
    id: 'camp_3',
    name: 'February Love Your Health',
    status: 'completed',
    startDate: '2024-02-01',
    endDate: '2024-02-29',
    targetSegment: 'Gold Members',
    rewardType: 'multiplier',
    budgetCap: 30000,
    budgetUsed: 28500,
    participants: 312,
    completions: 198,
  },
];

// Live redemptions for admin monitor
export const liveRedemptions = [
  {
    id: 'live_1',
    userId: 'usr_12345',
    userName: 'Sarah Chen',
    partner: 'FitLife Gym',
    voucherCode: 'PHYSIO-GYM-A7X9K2',
    pointsDeducted: 1000,
    timestamp: '2024-03-10T14:30:00',
    status: 'issued',
  },
  {
    id: 'live_2',
    userId: 'usr_23456',
    userName: 'Michael Tan',
    partner: 'Serenity Spa',
    voucherCode: 'PHYSIO-SPA-D8K3M2',
    pointsDeducted: 2000,
    timestamp: '2024-03-10T14:15:00',
    status: 'redeemed',
  },
  {
    id: 'live_3',
    userId: 'usr_34567',
    userName: 'Lisa Wong',
    partner: 'Physiomobile',
    voucherCode: 'PHYSIO-INT-F4N7P9',
    pointsDeducted: 2500,
    timestamp: '2024-03-10T13:45:00',
    status: 'issued',
  },
];

// ========== PARTNER MERCHANT DATA ==========

export const merchantData = {
  partnerId: 'partner_gym1',
  partnerName: 'FitLife Gym',
  branchName: 'FitLife Gym - KLCC Branch',
  todayRedemptions: 23,
  pendingSettlement: 12450,
  activeOffers: 4,
  totalLifetimeRedemptions: 1245,
};

export const merchantOffers = [
  {
    id: 'merch_offer_1',
    title: 'RM20 Gym Day Pass',
    pointsCost: 1000,
    quantity: 500,
    used: 245,
    validFrom: '2024-01-01',
    validTo: '2024-06-30',
    status: 'active',
  },
  {
    id: 'merch_offer_2',
    title: '1 Month Membership - 50% Off',
    pointsCost: 5000,
    quantity: 100,
    used: 67,
    validFrom: '2024-02-01',
    validTo: '2024-04-30',
    status: 'active',
  },
];

export const merchantRedemptionHistory = [
  {
    id: 'mred_1',
    voucherCode: 'PHYSIO-GYM-A7X9K2',
    offerTitle: 'RM20 Gym Day Pass',
    customerName: 'Sarah C.',
    validatedBy: 'Staff A',
    timestamp: '2024-03-10T10:30:00',
    status: 'validated',
  },
  {
    id: 'mred_2',
    voucherCode: 'PHYSIO-GYM-B5H2N8',
    offerTitle: 'RM20 Gym Day Pass',
    customerName: 'Ahmad R.',
    validatedBy: 'Staff B',
    timestamp: '2024-03-10T09:15:00',
    status: 'validated',
  },
];
